var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c0e17ecd9947ac94463348f03de9138c.svg#j';
                    var viewUrl = 'sprites.c0e17ecd9947ac94463348f03de9138c.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 62 58',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };